// extracted by mini-css-extract-plugin
export default {"confirmDialog":"ConfirmDialog_confirmDialog__j+-Q6","confirmDialogWithoutMessage":"ConfirmDialog_confirmDialogWithoutMessage__Bs025"};